import { axiosPost } from '../axios/axios.js'

export const changeBPState = {
  methods: {
    changeBPState: async function (objectId, state, props, errMsg) {
      this.$q.loading.show({ spinnerColor: 'blue-11' })

      const isReinforcementRequestBP = state.startsWith('RI')
      let businessProcess
      if (isReinforcementRequestBP) {
        businessProcess = 'reinforcement'
      }

      const bodyFormData = new FormData()
      bodyFormData.set('objectId', objectId)
      if (props != null) {
        bodyFormData.set('props', JSON.stringify(props))
      }

      await axiosPost({
        url: '/service/delta/' + businessProcess + '/' + state,
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Статус изменен',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          errMsg = errMsg || response.message
          this.$q.notify({
            type: 'negative',
            message: errMsg,
            progress: true,
            timeout: 8000
          })
        }
      })
        .finally(() => {
          this.$emit('task-updated')
          this.$q.loading.hide()
        })
    }
  }
}
